export enum IntegrationType {
    DEFAULT = 0,
    MERCADO_PAGO_RT = 1,
    MERCADO_PAGO = 2,
    PAYWAY = 3,
    DRAGON_FISH = 4,
    CENTUM = 5,
    FUDO = 6,
}
